export const quantityChange = (state, action) => ({
  ...state,
  activeItem: {
    ...state.activeItem,
    quantity: action.quantity,
    cartQuantity: action.quantity / state.activeItem.bundleSize,
  },
});
